import { useLayoutEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import Footer from "../components/Footer";
gsap.registerPlugin(ScrollTrigger);
const teamMembers = [{
  name: "Denis Bartolomei",
  role: "Chief Executive Officer",
  bio: "Ingegnere Gestionale, Ex consulente KPMG, EY-Parthenon, dove ha partecipato a progetti di trasformazione digitale, disegno di modelli operativi e organizzativi. Ha aiutato aziende e startup a costruire 15+ soluzioni basate su AI",
  image: "/lovable-uploads/98bf6340-b11a-424e-99ad-597edc9609d3.png"
}, {
  name: "Matteo Rosellini",
  role: "Research Director",
  bio: "Come Ingegnere Aeronautico ha svolto incarichi di consulenza sullo sviluppo aerodinamico e l'analisi CFD in ambito Motorsport. Attualmente è dottorando in fluidodinamica dedicando il suo lavoro all'impiego di modelli Data & AI per la comprensione e la simulazione del fenomeno della turbolenza",
  image: "/lovable-uploads/22e98195-eed2-4016-afb8-e79152e6ba1b.png"
}];

// Vision cards with custom content
const visionCards = [{
  title: "Ascoltando la voce dei clienti",
  description: "Costruiremo use-case in stretta collaborazione con i clienti, mirando a esigenze reali."
}, {
  title: "Modellando la tecnologia nei processi",
  description: "La tecnologia corre, noi la inseriremo nei processi nel migliore dei modi"
}, {
  title: "Generando impatti misurabili",
  description: "L'AI è potente, ma è misurandone il ROI che si coglie il vero potenziale"
}];
const Team = () => {
  const component = useRef(null);
  const titleRef = useRef(null);
  const membersRef = useRef<(HTMLDivElement | null)[]>([]);
  const visionCardsRef = useRef<(HTMLDivElement | null)[]>([]);
  const partnersTitleRef = useRef(null);
  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Animate title
      gsap.from(titleRef.current, {
        y: 50,
        opacity: 0,
        duration: 1,
        ease: "power3.out"
      });

      // Animate team members
      membersRef.current.forEach((member, index) => {
        gsap.from(member, {
          scrollTrigger: {
            trigger: member,
            start: "top 80%",
            toggleActions: "play none none reverse"
          },
          y: 50,
          opacity: 0,
          duration: 0.8,
          delay: index * 0.2,
          ease: "power3.out"
        });
      });

      // Animate partners title
      gsap.from(partnersTitleRef.current, {
        scrollTrigger: {
          trigger: partnersTitleRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse"
        },
        y: 50,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out"
      });

      // Animate vision cards
      visionCardsRef.current.forEach((card, index) => {
        gsap.from(card, {
          scrollTrigger: {
            trigger: card,
            start: "top 85%",
            toggleActions: "play none none reverse"
          },
          y: 30,
          opacity: 0,
          duration: 0.6,
          delay: index * 0.15,
          ease: "power3.out"
        });
      });
    }, component);
    return () => ctx.revert();
  }, []);
  return <div ref={component} className="min-h-screen bg-[#F8FAFF]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-16 md:pt-20 pb-24 md:pb-32">
        <div ref={titleRef} className="text-center mb-12 md:mb-16 pt-6 md:pt-10">
          <h1 className="text-3xl md:text-5xl lg:text-7xl mb-4 md:mb-6 px-0 font-medium">Il Team</h1>
          <p className="text-base md:text-xl lg:text-2xl text-gray-600 max-w-5xl mx-auto font-light px-4 md:px-0">Con Vertigo vogliamo costruire processi di assunzione più inclusivi ed efficienti, facendo leva sulle nostre esperienze.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {teamMembers.map((member, index) => <div key={index} ref={el => membersRef.current[index] = el} className="bg-white rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-lg transition-shadow duration-300 flex flex-col items-center text-center">
              <div className="mb-4 md:mb-6 w-32 h-32 md:w-40 md:h-40 overflow-hidden rounded-full">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover" />
              </div>
              <h3 className="text-xl md:text-2xl font-medium mb-1">{member.name}</h3>
              <p className="text-[#8B5CF6] font-medium mb-3 md:mb-4 text-sm md:text-base">{member.role}</p>
              <p className="text-gray-600 font-light text-sm md:text-base">{member.bio}</p>
            </div>)}
        </div>

        {/* Vision Section */}
        <div ref={partnersTitleRef} className="text-center mt-24 md:mt-32 mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl lg:text-7xl font-medium mb-4 md:mb-6 px-4 md:px-0">Dove puntiamo</h2>
          <p className="text-base md:text-xl lg:text-2xl text-gray-600 max-w-5xl mx-auto font-light px-4 md:px-0">Vogliamo creare soluzioni AI di riferimento per il mercato, generando impatti su aziende e candidati.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {visionCards.map((card, index) => <div key={index} ref={el => visionCardsRef.current[index] = el} className="bg-white rounded-2xl p-6 md:p-8 shadow-sm hover:shadow-lg transition-shadow duration-300 text-center">
              <h3 className="text-xl md:text-2xl font-medium mb-4 text-[#8B5CF6]">{card.title}</h3>
              <p className="text-gray-600 font-light text-sm md:text-base">{card.description}</p>
            </div>)}
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-4 md:bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3 md:gap-6 z-50 bg-white/80 backdrop-blur-sm px-3 py-3 md:px-6 md:py-3 rounded-full shadow-md">
        <Link to="/" className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 transition-colors duration-300">
          <Home size={14} className="md:w-4 md:h-4" />
        </Link>
        <div className="px-3 md:px-5 h-8 md:h-10 flex items-center justify-center rounded-full bg-black/80 text-white">
          <span className="text-xs font-medium">Team</span>
        </div>
        <Link to="/use-cases" className="px-3 md:px-5 h-8 md:h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 transition-colors duration-300">
          <span className="text-xs font-medium">Cosa facciamo</span>
        </Link>
        
      </div>
      
      <Footer />
    </div>;
};
export default Team;